module.exports = __webpack_public_path__ + "media/images/example_barcode-f26cd0cf6610db831e89163c0ca03eff.png";